export default __webpack_public_path__ + "static/media/money.3b716515.png";